/* import __COLOCATED_TEMPLATE__ from './teams-cell.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();